import { useCallback, useContext, useEffect, useState } from 'react';
import { UNSAFE_NavigationContext as NavigationContext } from 'react-router-dom';

function useConfirmExit(onConfirmAttempt: (retry: () => void) => void, when = true) {
    const { navigator } = useContext(NavigationContext);

    useEffect(() => {
        if (!when) return;

        const push = navigator.push;

        navigator.push = (...args: Parameters<typeof push>) => {
            const retry = () => push(...args);
            onConfirmAttempt(retry);
        };

        return () => {
            navigator.push = push;
        };
    }, [navigator, onConfirmAttempt, when]);
}

export function usePrompt(message: string, when = true) {
    const [retryNav, setRetryNav] = useState<(() => void) | null>(null);

    useEffect(() => {
        if (!when) return;

        window.onbeforeunload = () => message;
        return () => {
            window.onbeforeunload = null;
        };
    }, [message, when]);

    const onConfirmAttempt = useCallback((retry: () => void) => {
        setRetryNav(() => retry);
    }, []);

    useConfirmExit(onConfirmAttempt, when);
    return { retryNav, clearRetryNav: () => setRetryNav(null) };
}
